/**
 *  =================
 *  COOKIE CATEGORIES
 *  =================
 *
 *  personalization: personointi
 *
 */
"use strict";
const cookieExpiration = {
    name: "expirationTime",
    weekInMilliseconds: 15778476000,
};

const cookieCategories = {
    //  analytics: false,
    personalization: false,
};

window.addEventListener("DOMContentLoaded", () => {
    const btnOpenCookieConsent = document.querySelector("#open-cookie-consent");
    const cookieModal = document.querySelector("#cookie-modal");
    const elemOverlay = document.querySelector(".site-overlay");
    const elemBody = document.querySelector("body");
    const elemOverlayClose = document.querySelector(".site-search-header__close");
    const categoryKeys = Object.keys(cookieCategories);
    let focusedElement;

    /**
     * ============
     * COOKIE POPUP
     * ============
     */
    function initCheckboxes() {
        categoryKeys.forEach((storageItem) => {
            if (JSON.parse(localStorage.getItem(storageItem)) === true) {
                cookieCategories[storageItem] = true;
                document.getElementById(`cookies-${storageItem}`).checked = true;
                document.getElementById(`cookies-${storageItem}`).setAttribute("aria-checked", true);
            } else {
                document.getElementById(`cookies-${storageItem}`).setAttribute("aria-checked", false);
                const transparentCard = document.getElementById(`cookies-${storageItem}`).closest(".cookie-card");
                transparentCard.classList.add("transparent");
            }
        });
    }

    /**
     * @description basic controller for cookie pop up
     */
    function controlCookieModal() {
        initCheckboxes();
        cookieModal.focus({ preventScroll: true });
        //
        const cookiesPersonalization = document.getElementById("cookies-personalization");
        const btnSubmitCookieConsent = document.getElementById("set-cookie-consent");
        const btnAcceptAllCookies = document.getElementById("accept-cookies");
        const btnRejectAllCookies = document.getElementById("reject-cookies");
        const btnAcceptAllCookiesSettings = document.getElementById("accept-cookies-settings");

        //visual elements
        const elemSettingButtons = document.getElementById("cookie-selection-buttons");
        const elemSelectionButtons = document.getElementById("cookie-settings-buttons");
        const btnOpenCookieSettings = document.getElementById("open-cookie-settings");
        const consentForm = document.getElementById("cookie-consent-form");

        /**
         * @description accept all or certain levels of cookies
         * @param { Element } checkBox changed checkbox
         * @param { Boolean } all should check all, or one checkbox
         */
        function changeCheckboxStatus(checkBox, all) {
            if (all) {
                Object.keys(cookieCategories).forEach((key) => {
                    cookieCategories[key] = true;
                });
            } else {
                if (checkBox.checked === true) {
                    checkBox.closest(".cookie-card").classList.remove("transparent");
                } else {
                    checkBox.closest(".cookie-card").classList.add("transparent");
                }
                const currCategoryItem = checkBox.id.substring(checkBox.id.indexOf("-") + 1);
                cookieCategories[currCategoryItem] = !cookieCategories[currCategoryItem];
            }
        }
        //change consent pages

        btnOpenCookieSettings.addEventListener("click", function () {
            consentForm.style.display = "block";

            elemSettingButtons.classList.remove("d-flex");
            elemSettingButtons.classList.add("d-none");

            elemSelectionButtons.classList.remove("d-none");
            elemSelectionButtons.classList.add("d-flex");
        });

        // toggle checkboxes
        cookiesPersonalization.addEventListener(
            "change",
            changeCheckboxStatus.bind(this, cookiesPersonalization, false)
        );

        //submit changes
        btnSubmitCookieConsent.addEventListener("click", function (e) {
            e.preventDefault();
            controlCookies();
        });

        //set true values for all. uses global Object cookieCategories
        btnAcceptAllCookies.addEventListener("click", function (e) {
            e.preventDefault();
            Object.keys(cookieCategories).forEach((v) => (cookieCategories[v] = true));
            controlCookies();
        });

        btnRejectAllCookies.addEventListener("click", function (e) {
          e.preventDefault();
          Object.keys(cookieCategories).forEach((v) => (cookieCategories[v] = false));
          controlCookies();
        });

        btnAcceptAllCookiesSettings.addEventListener("click", function (e) {
            e.preventDefault();
            Object.keys(cookieCategories).forEach((v) => (cookieCategories[v] = true));
            controlCookies();
        });
    }

    /**
     * ============
     * CONTROL LOCALSTORAGE
     * ============
     */

    function controlCookies() {
        for (const key in cookieCategories) {
            localStorage.setItem(`${key}`, `${cookieCategories[key]}`);
        }
        localStorage.setItem(cookieExpiration.name, `${Date.now() + cookieExpiration.weekInMilliseconds}`);

        cookieModal.classList.add("closed");
        if (elemOverlay) {
            elemOverlay.classList.remove("is-active");
        }

        elemBody.classList.remove("has-active-overlay");
        if (elemOverlayClose) {
            elemOverlayClose.classList.remove("d-none");
        }
        focusedElement.focus({ preventScroll: false });
        window.location.reload(true);
    }

    /**
     * ============
     * INERT ELEMENTS
     * ============
     */

    /**
     * WCAG 2.1 2.4.3 Focus order fix
     */

    function inertElements() {
        const bodyChildren = document.body.querySelectorAll(':scope > div, :scope > nav');

        bodyChildren.forEach((element) => {
            if (document.querySelector("#cookie-modal") !== null) {
                if (element.id !== "cookie-modal") {
                    element.setAttribute("inert", "");
                }
            }
        });
    }

    /**
     * ============
     * INITIALIZE
     * ============
     */

    /**
     * @description show modal, if consent is expired
     * @returns { Boolean } is localstorage item expired
     */
    function isCookieConsentExpired() {
        const expirationStatus = localStorage.getItem(`${cookieExpiration.name}`);

        if (Date.now() >= expirationStatus || expirationStatus === null) {
            return true;
        } else {
            return false;
        }
    }

    if (isCookieConsentExpired()) {
        if (cookieModal) {
            const modalHeader = document.querySelector("#cookie-modal").querySelector("h3");

            cookieModal.classList.remove("closed");
            if (modalHeader) {
                modalHeader.setAttribute("tabindex", "0");
                modalHeader.focus({ preventScroll: true });
            }

            if (elemOverlay) {
                elemOverlay.classList.add("is-active");
            }

            elemBody.classList.add("has-active-overlay");
            if (elemOverlayClose) {
                elemOverlayClose.classList.add("d-none");
            }
            focusedElement = document.activeElement;
            controlCookieModal();
            inertElements();
        }
    }

    /**
     * reopen cookie consent from footer
     */
    if (btnOpenCookieConsent) {
        btnOpenCookieConsent.addEventListener("click", () => {
            localStorage.removeItem("expirationTime");
            location.reload(true);
        });
    }
});
